module.exports = __webpack_public_path__ + "static/retmes-ai-v1-9e13189ba54756ed8583c429d9b599a4.pdf";